import { render, staticRenderFns } from "./panelExpand.vue?vue&type=template&id=788c2558&scoped=true&"
import script from "./panelExpand.vue?vue&type=script&lang=js&"
export * from "./panelExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c2558",
  null
  
)

export default component.exports